import { render, staticRenderFns } from "./MySubjects.vue?vue&type=template&id=44395eea&"
import script from "./MySubjects.vue?vue&type=script&lang=js&"
export * from "./MySubjects.vue?vue&type=script&lang=js&"
import style0 from "./MySubjects.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports